<template>
  <v-os-popup
    class="refund-reason-popup"
    :title="`请选择${titleType[type]}原因（必选）`"
    v-model="show"
    @close="close"
    :backFnDisable="true"
  >
    <order-refund-reason
      :type="type"
      :tempTerminal="tempTerminal"
      :reasonList="reasonList"
      :showAddCartOption="showAddCartOption"
      :orderNo="orderNo"
      :orderType="orderType"
      :orderBase="orderBase"
      :fullPath="fullPath"
      :orderRenewVO="orderRenewVO"
      :orderEv="orderEv"
      :routerFun="routerFun"
      :orderCommodityUnits="orderCommodityUnits"
      :selectedIndex="selectedIndex"
      :disabledModifyAdress="disabledModifyAdress"
      :isList="isList"
      @close="close"
    ></order-refund-reason>
  </v-os-popup>
</template>
<script>
import OrderRefundReason from './component/reason'
export default {
  name: 'OrderRefundPopup',
  components: {
    OrderRefundReason
  },
  data: function () {
    return {
      operateType: { 1: '联系客服', 2: '立即修改', 3: '申请价保' },
      titleType: { cancel: '取消', refund: '退款', returnGoods: '退货' },
      show: false,
      type: 'cancel', // cancel or refund or returnGoods
      reasonList: [],
      orderNo: null,
      order: null,
      tempTerminal: -1,
      selectedIndex: -1,
      showAddCartOption: false,
      orderCommodityUnits: [],
      fullPath: '',
      orderRenewVO: '', //是否是以旧换新订单
      routerFun: null,
      orderType: '01',
      orderBase: {},
      orderEv: null,
      isWeChatApp: false,
      isList: false, // 表示该弹窗是否为订单列表页打开
      disabledModifyAdress: false,
      mutiRows: false,
      expanded: false,
      orderReasonDom: ''
    }
  },
  watch: {},
  computed: {},
  mounted() {},
  methods: {
    close() {
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>
.refund-reason-popup {
  ::v-deep .v-os-popup__content.contain-footer-pd {
    padding-bottom: 342px;
  }
  ::v-deep .v-os-popup__footer {
    padding: 0;
    height: auto;
  }
  ::v-deep .nx-sheets-fixed-content .content-slot {
    padding-bottom: 0;
  }
}
</style>
